<template>
<div class="row-edit-badge-section col-lg-12">
 <span class="message-info">
    Return reason
    </span>
 <div class="col-lg-12 no-padding"
    v-if="returnFields.length"
    v-for="returnField in returnFields"
    :key="returnField.id">
  <Radio-group
     v-if="returnField.choices.length < 5"
     @change="$emit('return_remarks',return_reason)"
     v-model="return_reason">
   <Radio v-for="returnField in returnField.choices"
     :key="returnField.label"
     :label="returnField.label">
     {{returnField.label}}
   </Radio>
  </Radio-group>
  <div v-else class="panel-select-option">
   <div class="dropdown-section">
    <Select v-model="return_reason" @change="$emit('return_remarks',return_reason)"
      default-first-option
      placeholder="Select">
       <Option
       v-for="item in returnField.choices"
       :key="item.name"
       :label="item.label"
       :value="item.label">
       </Option>
   </Select>
   </div>
  </div>
 </div>
</div>
</template>
<script>
export default {
  components: {},
  props: {
    returnFields: {
      type: Array,
    },
  },
  data() {
    return {
      return_reason: {},
      radio2: '',
      return_remarks: null,
    };
  },
  methods: {
    changeCustomfields(field) {
      const value = event.currentTarget.value;
      const cfields = this.cfields;
      cfields[field.name] = value;
    },
  },
};
</script>
<style lang='scss'>
</style>
